document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll("slider-component");

  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll(".slider__slide");
    const pagination = slider.querySelector(".slider-pagination");
    const prevBtn = slider.querySelector(".slider-button--prev");
    const nextBtn = slider.querySelector(".slider-button--next");
    if (!pagination) return;

    // Create dots dynamically
    slides.forEach((_, i) => {
      const dot = document.createElement("button");
      dot.classList.add("slider-dot");
      if (i === 0) dot.classList.add("is-active");
      pagination.appendChild(dot);
    });

    const dots = pagination.querySelectorAll(".slider-dot");
    let current = 0;

    // 🔥 FIXED FUNCTION — always removes ALL old is-active classes
    function showSlide(index) {
      // Clear ANY existing active slide (Shopify + custom slider)
      slider.querySelectorAll(".is-active").forEach(el => el.classList.remove("is-active"));

      slides.forEach((slide, i) => {
        slide.classList.toggle("is-active", i === index);
      });

      dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));

      current = index;
    }

    // Dot click → activate slide
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => showSlide(i));
    });

    // Next button
    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        const nextIndex = (current + 1) % slides.length;
        showSlide(nextIndex);
      });
    }

    // Prev button
    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        const prevIndex = (current - 1 + slides.length) % slides.length;
        showSlide(prevIndex);
      });
    }

    // MutationObserver for syncing active slide
    const observer = new MutationObserver(() => {
      slides.forEach((slide, i) => {
        if (slide.classList.contains("is-active")) {
          dots.forEach((dot, j) => dot.classList.toggle("is-active", i === j));
          current = i;
        }
      });
    });

    slides.forEach((slide) =>
      observer.observe(slide, { attributes: true, attributeFilter: ["class"] })
    );
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const firstAccordion = document.querySelector(".product__accordion details");
  if (firstAccordion) {
    firstAccordion.setAttribute("open", "");
  }
});
